<template>
  <div
    class="leftimgdiv"
    :style="leftimg"
    v-if="swiperSlideData && swiperSlideData.length > 0"
  >
    <div 
      class="mal-swiper"
      :style="leftimg"
      v-if="malSwiper.swiperSlide && malSwiper.swiperSlide.length > 0"
    >
      <div :class="inSwiper">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(slide, index) in swiperSlideData" :key="index">
            <a
              :href="slide.url === '' ? 'javascript:void(0)' : slide.url"
              target="_blank"
            >
              <img :src="slide.imgSrc" />
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="p"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper: swiper,
    "swiper-slide": swiperSlide,
  },
  data() {
    let option = this.$store.state.malMainPageConfig.malSwiper.option;
    let autoplayObject = false;
    if (option.autoplay === true) {
      autoplayObject = {
        delay: option.delay, //默认3秒切换一次
        disableOnInteraction: false,
      };
    }
    return {
      leftimg: {
        background: "url(" + require("./background.png") + ")",
      },
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: autoplayObject,
        speed: option.speed,
        pagination: {
          el: "#p",
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<span class="' +
              className +
              '" style="margin: 0 5px; width: 25px;height:3px;background: #FFFFFF;border-radius: 9px;outline:none"></span>'
            );
          },
        },
      },
    };
  },
  computed: {
    inSwiper: function () {
      let isShowAlways = this.$store.state.malMainPageConfig.nav.isShowAlways;
      if(isShowAlways){
        return "in-swiper1"
      }else{
        return "in-swiper";
      }
    },
    swiperSlideData: function () {
      return this.$store.state.malMainPageConfig.malSwiper.swiperSlide;
    },
    malSwiper: function () {
      return this.$store.state.malMainPageConfig.malSwiper;
    },
  },
};
</script>

<style scoped lang="scss">
.leftimgdiv {
  width: 100%;
  height: 380px;
}
.mal-swiper {
  display: flex;
  justify-content: center;
  height: 380px;
  width: 1200px;
  margin: 0 auto;
}
.in-swiper {
  position: relative;
  width: 1200px;
  height: 380px;
  z-index: 10;
}
.in-swiper1 {
  position: relative;
  width: 980px;
  height: 380px;
  z-index: 10;
  left:110px;
}
.mal-swiper img {
  width: 100%;
  height: 380px;
}
.in-swiper .swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
}
</style>
